import {Action} from '@reduxjs/toolkit'
import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest, takeLeading} from 'redux-saga/effects'

interface ActionWithPayload<T> extends Action {
  payload: T
}

const actionTypes = {
  SetFiscalYear: '[Set Fiscal Year] Action',
  SetFiscalYearPerkin: '[Set Fiscal Year Perjanjian Kinerja] Action',
  InitFiscalYearArray: '[Init Fiscal Year Array] Action',
  SetFiscalYearArray: '[Set Fiscal Year Array] Action',
}

const initialFiscalYearState: IFiscalYear = {
  fiscalYear: undefined,
  fiscalYearPerkin: undefined,
  fiscalYearArray: [] as number[],
}

interface IFiscalYear {
  fiscalYear?: number
  fiscalYearPerkin?: number
  fiscalYearArray?: number[]
}

function generateYears(): number[] {
  const currentYear = new Date().getFullYear()
  const startYear = 2020
  const yearsArray: number[] = []

  for (let year = currentYear; year >= startYear; year--) {
    yearsArray.push(year)
  }

  return yearsArray
}

export const reducer = persistReducer(
  {storage: storage, key: 'tahun-anggaran', whitelist: ['fiscalYear']},
  (state: IFiscalYear = initialFiscalYearState, action: ActionWithPayload<IFiscalYear>) => {
    switch (action.type) {
      case actionTypes.SetFiscalYear: {
        return {...state, fiscalYear: action.payload.fiscalYear}
      }
      case actionTypes.SetFiscalYearPerkin: {
        return {...state, fiscalYearPerkin: action.payload.fiscalYearPerkin}
      }
      case actionTypes.InitFiscalYearArray: {
        return {...state, fiscalYearArray: [] as number[]}
      }
      case actionTypes.SetFiscalYearArray: {
        return {...state, fiscalYearArray: action.payload.fiscalYearArray}
      }

      default:
        return state
    }
  }
)

export const actions = {
  setFiscalYear: (fiscalYear: number) => ({type: actionTypes.SetFiscalYear, payload: {fiscalYear}}),
  setFiscalYearPerkin: (fiscalYearPerkin: number) => ({
    type: actionTypes.SetFiscalYearPerkin,
    payload: {fiscalYearPerkin},
  }),
  initFiscalYearArray: () => ({type: actionTypes.InitFiscalYearArray}),
  setFiscalYearArray: (fiscalYearArray: number[]) => ({
    type: actionTypes.SetFiscalYearArray,
    payload: {fiscalYearArray},
  }),
}

export function* saga() {
  yield takeLatest(
    actionTypes.InitFiscalYearArray,
    function* generateFiscalYears({
      type,
      payload,
    }: {
      type: typeof actionTypes.SetFiscalYearArray
      payload: {fiscalYearArray: number[]}
    }) {
      yield put(actions.setFiscalYearArray(generateYears()))
      // yield console.log('next')
    }
  )
}
